import { TreeSelect } from '@alifd/next';
import wrapper from './next-wrapper';
const FormTreeSelect = wrapper(TreeSelect, 'CbayelFormTreeSelect');
export default FormTreeSelect;
